var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("default"),
      !_vm.loading && _vm.list.length === 0
        ? _vm._t("empty-view", function () {
            return [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "animate-css",
                      rawName: "v-animate-css",
                      value: "fadeIn",
                      expression: "'fadeIn'",
                    },
                  ],
                  staticClass:
                    "d-flex flex-column align-items-center justify-content-center py-5 px-2",
                },
                [
                  _vm.emptyImage
                    ? _c("b-img", {
                        staticClass: "mb-4",
                        attrs: {
                          src: _vm.emptyImage,
                          alt: _vm.$config.altImage,
                          width: "200",
                          height: "200",
                        },
                      })
                    : _vm._e(),
                  _vm.emptyTitle
                    ? _c(
                        "h4",
                        {
                          staticClass:
                            "text-muted text-center font-weight-bold",
                        },
                        [_vm._v(" " + _vm._s(_vm.emptyTitle) + " ")]
                      )
                    : _vm._e(),
                  _vm.emptyDescription
                    ? _c("span", { staticClass: "text-muted text-center" }, [
                        _vm._v(" " + _vm._s(_vm.emptyDescription) + " "),
                      ])
                    : _vm._e(),
                  _vm.emptyActionText
                    ? _c(
                        "brb-btn",
                        _vm._b(
                          {
                            staticClass: "mt-4",
                            on: {
                              click: function ($event) {
                                return _vm.$emit("empty-action-clicked")
                              },
                            },
                          },
                          "brb-btn",
                          _vm.emptyActionBind,
                          false
                        ),
                        [_vm._v(" " + _vm._s(_vm.emptyActionText) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-center" },
        [
          _vm.loading && _vm.list.length === 0
            ? _c("b-spinner", { staticClass: "m-5" })
            : _vm._e(),
          _vm.list.length < _vm.total
            ? _c(
                "brb-btn",
                {
                  attrs: { variant: "brb-primary", loading: _vm.loading },
                  on: { click: _vm.loadMore },
                },
                [_vm._v(" " + _vm._s(_vm.$t("forms.more")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }